import type { Language } from "@app/constants";

interface Message {
	error: {
		pleaseWait: string;
	};
	header: string;
	instruction: {
		line1: string;
		line2: string;
		line3: string;
		line4: string;
	};
	resendButton: string;
}

type MessageData = {
	[key in Language]: Message;
};

const messages: MessageData = {
	en: {
		error: {
			pleaseWait: "Please wait before trying again",
		},
		header: "Activate Account",
		instruction: {
			line1: "Your account has not yet been activated.",
			line2: "An activation email was previously sent to your email address.",
			line3: "If you did not receive this email, please resend it below.",
			line4: "You can login after your account has been activated.",
		},
		resendButton: "RESEND EMAIL",
	},
};

export default messages;
